import React, { useEffect, useState } from "react";

import { Box, Typography, TextField } from "@mui/material";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { DefensivePlayLog, RosterPlayer, TackleLog } from "../../../../types/LogTypes";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PlayerSelection } from "../Components/PlayerSelection";
import { useRoster } from "../../../../contexts/RosterContext";


export const DefenseTackleLog = () => {
  const [selectedPrimaryTackler, setSelectedPrimaryTackler] =
  useState<RosterPlayer| null>(null);
const [selectedAssistedTackler, setSelectedAssistedTackler] = useState<
  RosterPlayer[] | []
>([]);

const [tackleLog, setTackleLog] = useState<TackleLog | null>(null);

const [primaryJerseyNumber, setPrimaryJerseyNumber] = useState<string>("");
const [assistedJerseyNumbers, setAssistedJerseyNumbers] = useState<string[]>(
  []
);

const { defensePlayers } = useDepthChart();
const { currentPlayLog, setCurrentPlayLog, clearSelections } = useLogger();
const { rosterPlayers } = useRoster();

useEffect(() => {
  if (tackleLog && currentPlayLog) {
    setCurrentPlayLog({
      ...currentPlayLog,
      tackle: tackleLog
    } as DefensivePlayLog);
  }
}, [tackleLog]);

useEffect(() => {
  if (selectedPrimaryTackler) {
    setTackleLog({
      ...tackleLog,
      primary_tackler_roster_player: selectedPrimaryTackler,
    });
  }
}, [selectedPrimaryTackler]);

useEffect(() => {
  if (selectedAssistedTackler) {
    setTackleLog({
      ...tackleLog,
      assisted_tacklers_roster_players: selectedAssistedTackler,
    });
  }
}, [selectedAssistedTackler]);

useEffect(() => {
  if (clearSelections) {
    setSelectedPrimaryTackler(null);
    setSelectedAssistedTackler([]);
    setPrimaryJerseyNumber("");
    setAssistedJerseyNumbers([]);
  }
}, [clearSelections]);

const findTackler = (jerseyNumber: string) => {
  return rosterPlayers.find(
    (player) => player.jersey_number?.toString() === jerseyNumber
  );
};

const handlePrimaryJerseyNumberChange = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const value = event.target.value;
  if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
    setPrimaryJerseyNumber(value);
    const player = findTackler(value);
    if (player) {
      setSelectedPrimaryTackler(player);
    }
  }
};

const handlePrimaryTacklerSelection = (player: RosterPlayer) => {
  setSelectedPrimaryTackler(player);
  setPrimaryJerseyNumber(player.jersey_number?.toString() || "");
  if (selectedPrimaryTackler) {
  setTackleLog({
    ...tackleLog,
    primary_tackler_roster_player: selectedPrimaryTackler,
  });
  };
};

const handleSecondaryJerseyNumberChange = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const value = event.target.value;
  if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
    setAssistedJerseyNumbers([...assistedJerseyNumbers, value]);
    const player = findTackler(value);
    if (player) {
      setSelectedAssistedTackler([...selectedAssistedTackler, player]);
    }
  }
};

const handleSecondaryTacklerSelection = (player: RosterPlayer) => {
  setSelectedAssistedTackler([...selectedAssistedTackler, player]);
  setAssistedJerseyNumbers([
    ...assistedJerseyNumbers,
    player.jersey_number?.toString() || "",
  ]);
  if (selectedAssistedTackler) {
    setTackleLog({
      ...tackleLog,
      assisted_tacklers_roster_players: selectedAssistedTackler,
    });
  }
};


// TODO: Using the starting lineup is a good start, but there could be some other ideas to display them
// Also, if a jersey number is entered, it might make sense to add that to the displayed list.
// TLDR: use a smart function to determine which jerseys to display

return (
  <Box>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <PlayerSelection
        title="Primary Tackler"
        players={defensePlayers}
        selectedPlayer={selectedPrimaryTackler}
        jerseyNumber={primaryJerseyNumber}
        maxDisplayedPlayers={24}
        handlePlayerSelection={handlePrimaryTacklerSelection}
        handleJerseyNumberChange={handlePrimaryJerseyNumberChange}
        maxPlayersPerRow={8}
      />
    </Box>
    <Box>
      <PlayerSelection
        title="Assisted Tackler"
        players={defensePlayers}
        selectedPlayer={selectedAssistedTackler}
        jerseyNumber={assistedJerseyNumbers.join(", ")}
        maxDisplayedPlayers={24}
        maxPlayersPerRow={8}
        handlePlayerSelection={handleSecondaryTacklerSelection}
        handleJerseyNumberChange={handleSecondaryJerseyNumberChange}
      />
    </Box>
  </Box>
);
};
